import { render, staticRenderFns } from "./PersonEmptyFields.vue?vue&type=template&id=725bdd0a&"
import script from "./PersonEmptyFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./PersonEmptyFields.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PersonForm.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports